import axios from 'axios'
import { API_URL } from 'constants/global.constants'

export interface InventoryLedgerProcess {
  id: number
  name: string
  consumed: string | number
  returned: string | number
}

export interface InventoryLedgerMovement {
  id: number
  action: string
  notes: string | null
  created_at: string
  process_id: number | null
  process_name: string | null
  change: string | number
  balance_before: string | number
  balance_after: string | number
  credits_before: string | number
  credits_after: string | number
  used_before: string | number
  used_after: string | number
  user_id: number | null
  actor_name: string
}

export interface InventoryLedgerData {
  inventory: {
    credits: number
    tests_used: number
    available: number
    unlimited: boolean
  }
  processes: InventoryLedgerProcess[]
  totals: { consumed: string | number; increases: string | number }
  movements: InventoryLedgerMovement[]
  pagination: { total: number; page: number; limit: number; total_pages: number }
}

export const getInventoryLedger = async (inventoryId: number, page: number, processId: number | null, limit = 20): Promise<InventoryLedgerData> => {
  const response = await axios.get<{ status: string; data: InventoryLedgerData }>(
    `${API_URL}/subscription_company/${inventoryId}/ledger`,
    {
      params: { page, limit, ...(processId ? { process_id: processId } : {}) },
      headers: { Authorization: localStorage.getItem('token') },
    },
  )
  return response.data.data
}
